import SidebarCheckbox from "./SidebarCheckbox";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useGetAdminStaffOfficeList } from "repositories/office-repository";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";

const SidebarOfficeFilter = ({ allFiltersRef, resetFilters, preSetter }) => {
  const { selectedId } = useAccountOwnerCommon();
  const [multiSelection, setMultiSelection] = useState(preSetter || []);
  const { data: office_list } = useGetAdminStaffOfficeList(selectedId, {
    enabled: !!selectedId,
  });

  const dataTobeRender = useMemo(() => {
    return office_list?.data || [];
  }, [office_list]);

  const handleChange = useCallback((e, item) => {
    setMultiSelection((prev) => {
      if (e.target.checked) {
        return [...prev, item.id];
      }
      return prev.filter((res) => res !== item.id);
    });
  }, []);
  const handleAllChange = useCallback((e) => {
    setMultiSelection(() => {
      if (e.target.checked) {
        return [...dataTobeRender.map((res) => res.id)];
      }
      return [];
    });
  }, [dataTobeRender]);
  useEffect(() => {
    const officeIdsArray = allFiltersRef.current?.officeIds;
    if (officeIdsArray) {
      allFiltersRef.current.officeIds = multiSelection;
    }
  }, [multiSelection]);
  useEffect(() => {
    if (resetFilters) {
      setMultiSelection([]);
    }
  }, [resetFilters]);
  const officeslist= dataTobeRender.every(res=>multiSelection.includes(res.id))
  return (
    <SidebarCheckbox
      checked={({ id }) => multiSelection.includes(id)}
      handleChange={handleChange}
      data={dataTobeRender}
      allElement={(data) => {
        if (data.length) {
          return (
            <li className="border-bottom">
              <div className="ch-checkbox">
                <label>
                  <input
                    type="checkbox"
                    onChange={handleAllChange}
                    checked={officeslist}
                  />{" "}
                  <span>Select All</span>
                </label>
              </div>
            </li>
          );
        }
        return null
      }}
      renderName={(res) => res.name}
    />
  );
};
export default SidebarOfficeFilter;
